// @ts-nocheck

/**
 * CSS styles for the map component
 * These styles control cursor behavior and popup appearance
 */
export const mapCursorStyle = `
  .mapboxgl-canvas-container {
    cursor: default;
  }
  .mapboxgl-canvas-container.mapboxgl-interactive:hover {
    cursor: default;
  }
  .mapboxgl-canvas-container.mapboxgl-interactive[class*="cursor-"] {
    cursor: default;
  }
  .assets-fill-interactive:hover,
  .assets-line-interactive:hover,
  .assets-points-interactive:hover,
  .assets-hover-area-interactive:hover,
  .mapboxgl-canvas-container.mapboxgl-interactive.cursor-pointer {
    cursor: pointer !important;
  }
  
  /* Unified style for all tooltips */
  .mapboxgl-popup-content {
    border-left: 3px solid #879643;
    background-color: rgba(255, 255, 255, 0.95);
    box-shadow: 0 3px 14px rgba(0, 0, 0, 0.2);
    max-width: 200px;
    padding: 10px 12px;
    border-radius: 8px;
  }
  
  /* Mobile-specific tooltip styles */
  @media (max-width: 768px) {
    .mapboxgl-popup-content {
      max-width: 240px;
      padding: 12px 15px;
      font-size: 16px;
    }
    
    .mapboxgl-popup {
      z-index: 10 !important;
    }
    
    /* Increase tap target size */
    .mapboxgl-popup-close-button {
      padding: 8px;
      font-size: 20px;
      right: 6px;
      top: 6px;
    }
  }
  
  /* Adjust the overall z-index for tooltips when all are shown */
  .all-features-popup {
    z-index: 1 !important;
  }
  
  /* Make the popup point more visible */
  .mapboxgl-popup-tip {
    border-width: 10px;
    margin-top: -10px;
  }
`;

/**
 * Map box token for authentication
 */
export const MAPBOX_TOKEN = "pk.eyJ1IjoiY3JhaWdtYWMwMDciLCJhIjoiY2xkbHNlZ3h1MDE2bjNxcGJjYWo5YzRtMCJ9.ezesyu3cASMlnZlJLMkZwg";